"use client";
//#region packages/@mantine/core/src/components/AppShell/AppShellMediaStyles/is-responsive-size/is-responsive-size.ts
function isResponsiveSize(size) {
	if (typeof size !== "object" || size === null) return false;
	if (Object.keys(size).length === 1 && "base" in size) return false;
	return true;
}
//#endregion
export { isResponsiveSize };

//# sourceMappingURL=is-responsive-size.mjs.map